import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  className = "",
}) => {
  if (totalPages <= 1) return null;

  const startItem = currentPage * itemsPerPage + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      // Small number of pages, show all
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Many pages, show smart pagination
      if (currentPage <= 3) {
        // Near start
        pages.push(0, 1, 2, 3, 4, "dots", totalPages - 1);
      } else if (currentPage >= totalPages - 4) {
        // Near end
        pages.push(
          0,
          "dots",
          totalPages - 5,
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1
        );
      } else {
        // Middle
        pages.push(
          0,
          "dots",
          currentPage - 2,
          currentPage - 1,
          currentPage,
          currentPage + 1,
          currentPage + 2,
          "dots",
          totalPages - 1
        );
      }
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <div className={`d-flex justify-content-between align-items-center mt-3 ${className}`}>
      <div>
        Showing {startItem} to {endItem} of {totalItems} entries
      </div>
      <div>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          disabled={currentPage === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>

        {pages.map((p, i) =>
          p === "dots" ? (
            <span key={i} className="me-2">
              ...
            </span>
          ) : (
            <button
              key={i}
              className={`btn btn-sm border me-2 ${
                currentPage === p ? "btn-primary text-white" : ""
              }`}
              onClick={() => onPageChange(p)}
            >
              {p + 1}
            </button>
          )
        )}

        <button
          className="btn btn-sm btn-outline-primary"
          disabled={currentPage === totalPages - 1}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
